export default __webpack_public_path__ + "static/media/map-icon.4f093455.svg";